export const oneTypeDetailCn = {
    zaixianxunjia:"在线询价",
    jcrzfw:"检测认证服务"
}


// WEBPACK FOOTER //
// ./src/lang/home/oneTypeDetail/oneTypeDetailCn.js